import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/testimonials";
type CtaButtonProps = {
  label?: string;
  variant?: "walnut" | "linen" | "brass";
  className?: string;
};
export function CtaButton({
  label = "Je veux le pack pour 27 USD",
  variant = "walnut",
  className = ""
}: CtaButtonProps) {
  const variants = {
    walnut: "bg-walnut text-linen hover:bg-walnut-deep focus-visible:ring-walnut focus-visible:ring-offset-cream",
    linen: "bg-linen text-walnut-deep hover:bg-sand focus-visible:ring-linen focus-visible:ring-offset-walnut",
    brass: "bg-brass text-ebony hover:bg-[#D6B472] focus-visible:ring-brass focus-visible:ring-offset-ebony"
  };
  const styles = variants[variant];
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] shadow-[0_10px_24px_-12px_rgba(63,39,23,0.6)] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${styles} ${className}`} data-id="element-68" data-mp="19b1l1t0iu41f">
      {label}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-69" data-mp="3f071lc8s2b4k" />
    </a>;
}